/**
 * A sale's name as a screen says it.
 *
 * The name used to be the key as well: the sales catalog keyed a sale by it, a
 * follow was stored under it, and the My Sales union matched on it — so trimming
 * had to be done for the eye alone or a follow would have been lost. The key is now the sale's minted `saleRefId`, and the name
 * is only ever drawn, which is what makes this safe rather than delicate.
 *
 * It lives in the SDK because both halves need it: a store deciding that two
 * names which differ by a space are the same words about one sale, and a screen
 * drawing one. The portal's `utils/saleDisplayName.js` re-exports it, so this is
 * the only definition.
 *
 * @param {unknown} name
 * @returns {string}
 */
export function saleDisplayName(name) {
    return String(name ?? '').trim();
}

export default saleDisplayName;
